package com.devi3east.bashbuddy.cart.storage

import com.devi3east.bashbuddy.cart.domain.models.CartItem
import kotlinx.browser.window
import kotlinx.serialization.json.Json

class WebCartStorage : CartStorage {
    private val key = "bashbuddy_cart"

    override fun load(): List<CartItem> {
        val raw = window.localStorage.getItem(key) ?: return emptyList()
        return Json.decodeFromString(raw)
    }

    override fun save(items: List<CartItem>) {
        window.localStorage.setItem(key, Json.encodeToString(items))
    }

    override fun clear() {
        window.localStorage.removeItem(key)
    }
}